import { t } from 'ember-intl';

<template>
  <h1 class="sr-only">{{t "page_headings.planning_for_college"}}</h1>
</template>
